var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    className: "dark-close-icon",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .dark-close-icon .a {\n            fill:#fff;\n            stroke:#f5f6f7;\n            }\n            .dark-close-icon .a, .dark-close-icon .b {\n            opacity:0;\n            }\n            .dark-close-icon .b, .dark-close-icon .c {\n            fill:#41485a;\n            stroke:#41485a;\n            }\n            .dark-close-icon .c {\n            stroke-width:0.4px;\n            }\n            .dark-close-icon .d {\n            stroke:none;\n            }\n            .dark-close-icon .e {\n            fill:none;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.234 34) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(2.234 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 32,
    height: 32,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1112.772 107.539) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1086 81)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-0.461 -0.461)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.93 0.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.527,7.68l6.655-6.655a.6.6,0,0,0-.848-.848L7.679,6.831,1.024.176a.6.6,0,0,0-.848.848L6.83,7.68.175,14.334a.6.6,0,0,0,.848.848L7.679,8.528l6.655,6.655a.6.6,0,1,0,.848-.848Z",
    transform: "translate(0 -0.001)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCloseIcon);
export default __webpack_public_path__ + "static/media/dark-close-icon.74cd9b41d1e9f40b4d211539ce96a059.svg";
export { ForwardRef as ReactComponent };